import { render, staticRenderFns } from "./wxmpLink.vue?vue&type=template&id=c313031a&scoped=true"
import script from "./wxmpLink.vue?vue&type=script&lang=js"
export * from "./wxmpLink.vue?vue&type=script&lang=js"
import style0 from "./wxmpLink.vue?vue&type=style&index=0&id=c313031a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c313031a",
  null
  
)

export default component.exports